import type { VccStatusDisplayInfo } from 'app/typings/core/common/enum/vccStatus';
import type { VccStatusData } from 'app/typings/vcc';

export type VirtualCardData = {
  issuingCardId?: string;
  issuingBalance: number;
  checkin: string;
  code: string;
};

export type VccStatusType = VccStatusData | VccStatusDisplayInfo;

export const isLegacyVccStatus = (
  status: VccStatusType
): status is VccStatusData => 'history' in status;

export const isModernVccStatus = (
  status: VccStatusType
): status is VccStatusDisplayInfo => !('history' in status);

export type VirtualCardConfig = {
  currencyFormatter: (price?: number) => string;
  cardIsBlur: boolean;
  status: VccStatusType;
};
